<!-- src/lib/components/ItemPerPageSelect.svelte -->
<script>
  export let options;
  export let onSelect = (/** @type {{ label: string; value: number; }} */ option) => {};
</script>

<ul class="custom-select__options">
  {#each options as option}
    <li class="custom-select__option">
      <button
        type="button"
        class="custom-select__button"
        on:click={() => onSelect(option)}
      >
        {option.label}
      </button>
    </li>
  {/each}
</ul>
